import CalendlyScheduleDialog from './CalendlyScheduleDialog';
import FadeIn from '@/shared/components/FadeIn';
import PannellumViewer from '@/shared/components/PannellumViewer';

const ProductStorySection: React.FC = () => {
  return (
    <section id="about-us" className="relative overflow-hidden bg-maintenance-dark min-h-[80vh]">
      {/* Live 360 panorama — right 60% on desktop, full width on mobile */}
      <div className="absolute inset-y-0 right-0 w-full lg:w-[62%]">
        <PannellumViewer
          src="/static/images/panorama_asbuild.jpg"
          autoRotate={-5}
          draggable
          hfov={110}
          pitch={-5}
        />

        {/* Left-side gradient — blends viewer into the dark text area */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              'linear-gradient(to right, #1e293b 0%, #1e293b 5%, rgba(30,41,59,0.85) 25%, rgba(30,41,59,0.3) 55%, transparent 100%)',
          }}
        />
        {/* Bottom fade for seamless section transition */}
        <div className="absolute inset-x-0 bottom-0 h-40 pointer-events-none bg-gradient-to-t from-maintenance-dark to-transparent" />
        {/* Top fade */}
        <div className="absolute inset-x-0 top-0 h-24 pointer-events-none bg-gradient-to-b from-maintenance-dark to-transparent" />
      </div>

      {/* Text content — sits in front of the viewer */}
      <div className="relative z-10 container mx-auto px-6 md:px-12 lg:px-16 py-28 md:py-36">
        <div className="max-w-xl lg:max-w-2xl">
          <FadeIn>
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-[1.05] mb-8">
              Your entire jobsite,<br />
              <span className="text-maintenance-cyan">captured for you.</span>
            </h2>
          </FadeIn>

          <FadeIn delay={150}>
            <p className="text-white/70 text-lg md:text-xl leading-relaxed mb-6">
              Ironview 360 gives every project stakeholder a permanent, navigable record of the
              construction site — accessible from anywhere, at any milestone. No travel, no
              guesswork, no disputes.
            </p>
            <p className="text-white/50 text-base md:text-lg leading-relaxed mb-10">
              From underground utilities to finished floors, our platform layers drone captures,
              360-degree walkthroughs, and as-built documentation into a single source of truth your
              whole team can rely on.
            </p>
          </FadeIn>

          <FadeIn delay={280}>
            <div className="flex flex-col sm:flex-row items-start gap-4">
              <CalendlyScheduleDialog
                triggerText="See It in Action"
                fullWidthMobile={false}
                className="px-8 py-3 text-base"
              />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default ProductStorySection;
